<template>
  <div>
    <a-card title="库存流水">
      <a-row gutter="16">
        <a-col :span="8" :md="8" :xl="6" style="max-width: 256px; margin-bottom: 12px;">
          <a-input-search v-model="searchForm.search" placeholder="单号" allowClear @search="search"/>
        </a-col>
        <a-col :span="24" :md="8" :xl="6" style="max-width: 256px; margin-bottom: 12px;">
          <a-select v-model="searchForm.warehouse" placeholder="仓库" allowClear style="width: 100%;" @change="search">
            <a-select-option :value="null">所有仓库</a-select-option>
            <a-select-option v-for="item in warehouseItems" :key="item.id" :value="item.id">{{ item.name }}
            </a-select-option>
          </a-select>
        </a-col>
        <!-- 在文档3的 <a-row gutter="16"> 区块中添加 -->
        <a-col :span="24" :md="8" :xl="6" style="max-width: 256px; margin-bottom: 12px;">
          <a-select
              v-model="searchForm.type"
              placeholder="流水类型"
              allowClear
              style="width: 100%;"
              @change="search"
          >
            <a-select-option :value="null">所有类型</a-select-option>
            <a-select-option v-for="item in typeItems" :key="item.value" :value="item.value">
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-col>
      </a-row>
      <a-descriptions :column="{ xxl: 4, xl: 4, lg: 4, md: 2, sm: 2, xs: 1 }" style="text-align: center;">

        <a-descriptions-item label="数量"><span class="total">{{ totalQuantity }}</span></a-descriptions-item>

      </a-descriptions>
      <a-row style="margin-top: 12px;">
        <a-table size="small" :columns="columns" :dataSource="items" rowKey="id" :loading="loading"
                 :pagination="pagination"
                 @change="tableChange">
          <div slot="action" slot-scope="value, item">
            <a-button-group size="small">
              <a-button size="small" @click="detial(item)">详情</a-button>
            </a-button-group>
          </div>
        </a-table>
      </a-row>
    </a-card>
  </div>
</template>

<script>
import {inventoryFlowsList} from '@/api/warehouse'
import {warehousesOption} from '@/api/option'
import moment from "moment/moment";

export default {
  name: 'SaleRecord',
  components: {},
  data() {
    return {
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          customRender: (value, item, index) => {
            return index + 1
          },
          width: 45
        },
        {
          title: '仓库',
          dataIndex: 'warehouse_name',
        },
        {
          title: '产品名称',
          dataIndex: 'goods_name',
        },
        {
          title: '产品编号',
          dataIndex: 'goods_number',
        },
        {
          title: '流水类型',
          dataIndex: 'type_display',
        },
        {
          title: '变化之前数量',
          dataIndex: 'quantity_before',
        },
        {
          title: '变化数量',
          dataIndex: 'quantity_change',
        },
        {
          title: '变化之后数量',
          dataIndex: 'quantity_after',
        },
        {
          title: '创建日期',
          dataIndex: 'create_time',
          width: 170
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: {customRender: 'action'},
          width: 80
        },
      ],

      searchForm: {
        page: 1,
        page_size: 16,
        warehouse: null, // 默认值为 null，表示“所有仓库”
        has_stock: true,
        dateRange: [moment().startOf('day'), moment().startOf('day')],
      },
      pagination: {current: 1, total: 0, pageSize: 16},
      loading: false,
      items: [],
      typeItems: [
        {value: 'stock_transfer_in', label: '调拨转入'},
        {value: 'stock_transfer_out', label: '调拨转出'},
        {value: 'purchase', label: '采购'},
        {value: 'sales', label: '销售'},
        {value: 'void_purchase', label: '作废采购'},
        {value: 'purchase_return', label: '采购退货'},
        {value: 'void_purchase_return', label: '作废采购退货'},
        {value: 'void_sales', label: '作废销售'},
        {value: 'sales_return', label: '销售退货'},
        {value: 'void_sales_return', label: '作废销售退货'},
        {value: 'stock_in', label: '入库'},
        {value: 'void_stock_in', label: '作废入库'},
        {value: 'stock_out', label: '出库'},
        {value: 'void_stock_out', label: '作废出库'},
        {value: 'stock_check', label: '盘点'},
        {value: 'void_stock_check', label: '作废盘点'},
        {value: 'void_stock_transfer_out', label: '作废调拨转出'},
        {value: 'void_stock_transfer_in', label: '作废调拨转入'}
      ],
      visible: false,
      targetItem: {},
      form: {},
    };
  },
  computed: {
      totalQuantity() {
    const sum = this.items.reduce((sum, item) => sum + (item.quantity_change || 0), 0)
    return sum.toLocaleString('en-US') // 显示为 449 => "449"（若含小数则显示为"123,456.78"）
  }
  },
  methods: {
    initialize() {
      warehousesOption({page_size: 100}).then(resp => {
        this.warehouseItems = resp.results;
      });
      this.list();
    },
    list() {
      this.loading = true;
      inventoryFlowsList(this.searchForm).then(data => {
        this.pagination.total = data.count;
        this.items = data.results;
      }).finally(() => {
        this.loading = false;
      });
    },
    tableChange(pagination, filters, sorter) {
      this.searchForm.page = pagination.current;
      this.pagination.current = pagination.current;
      this.searchForm.ordering = `${sorter.order == 'descend' ? '-' : ''}${sorter.field}`;
      this.list();
    },
    onChangePicker(date, dateString) {
      let startDate = date[0], endDate = date[1];
      this.searchForm.start_date = startDate ? startDate.format('YYYY-MM-DD') : undefined;
      this.searchForm.end_date = endDate ? endDate.add(1, 'days').format('YYYY-MM-DD') : undefined;
      this.search();
    },
    search() {
      this.searchForm.page = 1;
      this.pagination.current = 1;
      this.list();
    },
    detial(item) {
      this.$router.push({path: '/warehouse/flow_detail', query: {item: JSON.stringify(item)}});
    },
  },
  mounted() {
    this.initialize();
  },
}
</script>